import styled from 'styled-components';
import * as UIConstants from "../../../../../UIConstants";

interface WeeekDaysProps {
    isSelected: boolean
}

interface showProp {
    show: boolean
}

export const CreateLotteryContainer = styled.div`
width: 100%;
box-sizing: border-box;
display:flex;
flex-flow: row nowrap;
align-items: flex-start;
justify-content: flex-start;
gap: 24px;
margin-top: 25px;
form{
    width: 100%;
    box-sizing: border-box;
}
${UIConstants.customView}{
display:inline-block;

}
`;
export const CreateLotteryContainerMobile = styled.div`
width: 100%;
box-sizing: border-box;
// display: flex;
// flex-flow: row nowrap;
// align-items: flex-start;
// justify-content: flex-start;
// gap: 24px;
margin-top: 25px;
form{
    width: 100%;
    box-sizing: border-box;
}
`;

export const CreateLotteryFirstSection = styled.div`
display: flex;
flex-flow: column;
align-items: center;
justify-content: flex-start;
flex-basis: 60%;
${UIConstants.customView}{
flex-basis: 100%;

}
`;

export const CreateLotterySecondSection = styled.div`
display: flex;
flex-flow: column;
align-items: center;
justify-content: flex-start;
flex-basis: 40%;
`;

export const WeekNames = styled.span`
display: inline-block;
border: 1px solid transparent;
border-color: ${(props: WeeekDaysProps) => !props.isSelected ? "#ADB5BD" : "#3A57E8"};
background-color: ${(props: WeeekDaysProps) => !props.isSelected ? "#ffffff" : "#3A57E8"};
color: ${(props: WeeekDaysProps) => !props.isSelected ? "#000000" : "#ffffff"};
margin-right: 10px;
padding: 3px 8px;
font-size: 14px;
border-radius: 8px;
cursor: pointer;
`;

export const FormElementTitle = styled.div`
width: 100%;
box-sizing: border-box;
margin: 18px 0;
color: #200E32;
font-size:14px;
`;

export const FormSectionContainer = styled.div`
background-color: #ffffff;
box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12);
border-radius: 8px;
padding: 30px;
margin-bottom: 24px;
`;

export const SectionTitle = styled.div`
width: 100%;
box-sizing: border-box;
font-size: 18px;
font-weight: 500;
padding: 0 30px 24px 0;
border-bottom: 1px solid #E9EDF5;
margin-bottom: 24px;
`;
export const UpdateTitle = styled.div<showProp>`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
box-sizing: border-box;
font-size: 18px;
font-weight: 500;
padding: ${(props: showProp) => props.show ? "0 30px 24px 0" : "0 30px 0px 0"};
border-bottom: ${(props: showProp) => props.show ? "1px solid #E9EDF5" : ""};
margin-bottom: ${(props: showProp) => props.show ? "24px" : "0px"};
`;


export const LotteryTypeTitle = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
font-size: 12px;
color:#687182;
font-weight: 500;
text-transform: uppercase;
`;

export const LotteryTypeValue = styled.div`
width: 100%;
box-sizing: border-box;
color: #3A57E8;
font-size: 14px;
font-weight: 500;
text-transform: uppercase;
margin-top: 16px;
`;

export const TwoFormSection = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
align-items: flex-start;
justify-content: flex-start;
gap: 10px;
`;
export const WinnerTwoFormSection = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
align-items: flex-end;
justify-content: flex-end;
gap: 10px;
`;

export const FormView = styled.div`
width: 100%;
box-sizing: border-box;
flex-flow: column;
`;

export const Action = styled.div`
width: 100%;
box-sizing: border-box;
display: flex
justify-content: flex-start;
text-align: center;
margin: 15px 0;
padding-right:35px;
Button: first-child{
    margin-right: 15px;
}
${UIConstants.customView}{
text-align: right;
padding-right:0px;


}
`;

export const UploadImageBtnSection = styled.div`
width: 100%;
box-sizing: border-box;
text-align: right;
`;
export const IndImgWrapper = styled.div`
position: relative;
`;

export const Image = styled.img`
height: 85px;
width: 85px;
min-height: 85px;
min-width: 85px;
object-fit: contain;
border: 1px solid #ccc;
border-radius: 4px;
`;
export const EmptyImgSection = styled.div`
width: 100%;
box-sizing: border-box;
padding: 24px ;
text-align: center;
font-weight: 400;
font-size: 18px;
line-height: 20px;
color: #ADB5BD;

`;

export const ImageSection = styled.div`
width: 100%;
box-sizing: border-box;
margin-bottom: 24px;
`;
export const ImageWrapper = styled.div`
width: 100%;
box-sizing: border-box;
padding:24px 24px 24px 24px;
background-color: #ffffff;
border-bottom-right-radius: 6px;
border-bottom-left-radius: 6px;
display: flex;
// flex-flow: row nowrap;
flex-wrap:wrap;
align-items: flex-start;
justify-content: flex-start;
gap: 15px;
${UIConstants.customView}{
// padding:64px 24px 64px 24px;
    
}
`;

export const ImageContainer = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: column;
align-items: flex-start;
justify-content: flex-start;
background-color: #ffffff;
border-radius: 8px;
box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12);
// border:1px solid gray;
`;

export const TitleWrapper = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
align-items: center;
justify-content: space-between;
padding: 20px 24px 20px 24px;
border-bottom: 1px solid #E9EDF5;
`;
export const Title = styled.div`
font-weight: 500;
font-size: 18px;
letter-spacing: 0.0024em;
color: #200E32;
`;



